<div class="prescription-details-layout" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px">
  <div fxFlex class="prescription-details-main" [formGroup]="formGroup">

    <div class="rx-task-strip" *ngIf="pendingRxTask">
      <mat-form-field appearance="fill" class="rx-task-type">
        <mat-label>TASK</mat-label>
        <input matInput [value]="pendingRxTask.label" readonly>
      </mat-form-field>
      <mat-form-field
        *ngIf="pendingRxTask.kind === 'open'"
        appearance="fill"
        class="rx-task-field"
      >
        <mat-label>WHO TO CALL</mat-label>
        <mat-select [formControl]="taskWhoToCall">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let option of whoToCallOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="pendingRxTask.kind === 'awaiting'"
        appearance="fill"
        class="rx-task-field"
      >
        <mat-label>EXAM DATE</mat-label>
        <input matInput [matDatepicker]="taskExamDate" formControlName="examDate">
        <mat-datepicker-toggle matSuffix [for]="taskExamDate"></mat-datepicker-toggle>
        <mat-datepicker #taskExamDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" class="rx-task-field">
        <mat-label>STATUS</mat-label>
        <mat-select [formControl]="taskStatusChoice">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let option of pendingRxTask.actions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="rx-task-initials">
        <mat-label>INITIALS</mat-label>
        <input matInput maxlength="4" autocomplete="off" [formControl]="taskInitials">
      </mat-form-field>
      <button mat-stroked-button color="primary" type="button" class="rx-task-save" (click)="savePendingRxTask()">
        SAVE
      </button>
    </div>

    <div class="rx-record-row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <button mat-button type="button" class="rx-new-button" (click)="startNewPrescription()">
        + NEW PRESCRIPTION
      </button>
      <mat-form-field appearance="fill" fxFlex>
        <mat-label>RX USE</mat-label>
        <mat-select
          [value]="formGroup.get('_id')?.value"
          (selectionChange)="onSelectExistingRx($event.value)"
        >
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let rx of activePrescriptions" [value]="rx._id">
            {{ rxUseLabel(rx) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" fxFlex>
        <mat-label>NEW NAME</mat-label>
        <input
          matInput
          [formControl]="newNameControl"
          [matAutocomplete]="newNameAuto"
          autocomplete="off"
        >
        <mat-autocomplete #newNameAuto="matAutocomplete">
          <mat-option *ngFor="let option of filteredRxNames" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width:140px;">
        <mat-label>EXAM DATE</mat-label>
        <input matInput [matDatepicker]="pickerExamDate" formControlName="examDate">
        <mat-datepicker-toggle matSuffix [for]="pickerExamDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerExamDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width:120px;">
        <mat-label>EXPIRES</mat-label>
        <mat-select formControlName="oneYearExpiration">
          <mat-option [value]="true">1 YEAR</mat-option>
          <mat-option [value]="false">2 YEARS</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="rx-hide">
        <label>HIDE</label>
        <mat-checkbox formControlName="hide"></mat-checkbox>
      </div>
      <button mat-button type="button" (click)="openRxHistory()">VIEW RX HISTORY</button>
    </div>
    <div class="rx-expires-on" *ngIf="formGroup.get('expirationDate')?.value">
      {{ formGroup.get('expirationDate')?.value | date:'M/d/yyyy' }}
    </div>

    <div class="rx-verify-banner" *ngIf="extractedUnverified">
      UPLOADED RX — OPTICIAN VERIFICATION REQUIRED. Compare the original
      with the values below and acknowledge they are accurate before saving.
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" formGroupName="right">
      <div fxFlex="7%"><b>RIGHT</b></div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="SPH" type="text" class="form-control" formControlName="sph">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="CYL" type="text" class="form-control" formControlName="cyl">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="AXIS" type="text" class="form-control" autocomplete="off" formControlName="axis">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="ADD" type="text" class="form-control" formControlName="add">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="SEG HGT" [readonly]="true" type="text" class="form-control" formControlName="segHgt">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PRISM" type="text" class="form-control" formControlName="prism1">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <mat-select placeholder="B" formControlName="b1">
            <mat-option value="U">U</mat-option>
            <mat-option value="D">D</mat-option>
            <mat-option value="O">O</mat-option>
            <mat-option value="I">I</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PRISM" type="text" class="form-control" formControlName="prism2">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <mat-select placeholder="B" formControlName="b2">
            <mat-option value="U">U</mat-option>
            <mat-option value="D">D</mat-option>
            <mat-option value="O">O</mat-option>
            <mat-option value="I">I</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PD DIST" type="text" class="form-control" formControlName="pdd">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PD NEAR" type="text" class="form-control" formControlName="pdn">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="OC" type="text" class="form-control" formControlName="oc">
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" formGroupName="left">
      <div fxFlex="7%"><b>LEFT</b></div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="SPH" type="text" class="form-control" formControlName="sph">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="CYL" type="text" class="form-control" formControlName="cyl">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="AXIS" type="text" class="form-control" autocomplete="off" formControlName="axis">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="ADD" type="text" class="form-control" formControlName="add">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="SEG HGT" [readonly]="true" type="text" class="form-control" formControlName="segHgt">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PRISM" type="text" class="form-control" formControlName="prism1">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <mat-select placeholder="B" formControlName="b1">
            <mat-option value="U">U</mat-option>
            <mat-option value="D">D</mat-option>
            <mat-option value="O">O</mat-option>
            <mat-option value="I">I</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PRISM" type="text" class="form-control" formControlName="prism2">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <mat-select placeholder="B" formControlName="b2">
            <mat-option value="U">U</mat-option>
            <mat-option value="D">D</mat-option>
            <mat-option value="O">O</mat-option>
            <mat-option value="I">I</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PD DIST" type="text" class="form-control" formControlName="pdd">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="PD NEAR" type="text" class="form-control" formControlName="pdn">
        </mat-form-field>
      </div>
      <div fxFlex="7%">
        <mat-form-field style="width:100%">
          <input matInput placeholder="OC" type="text" class="form-control" formControlName="oc">
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="showProminentNotes; else compactNotes">
      <mat-form-field appearance="fill" class="rx-notes-open" style="width:100%">
        <mat-label>Add note</mat-label>
        <textarea matInput rows="4" formControlName="notes"></textarea>
      </mat-form-field>
    </div>
    <ng-template #compactNotes>
      <mat-form-field appearance="fill" class="rx-notes-open" style="width:100%">
        <mat-label>Notes</mat-label>
        <textarea matInput rows="2" formControlName="notes"></textarea>
      </mat-form-field>
    </ng-template>

    <mat-checkbox
      class="rx-verify-check"
      *ngIf="extractedUnverified"
      [checked]="verified"
      (change)="verified = $event.checked"
    >
      I ACKNOWLEDGE THIS IS ACCURATE
    </mat-checkbox>

    <div class="rx-used" *ngIf="orderForm.get('rxName')?.value">
      RX USED: {{ orderForm.get('rxName')?.value }}
    </div>
  </div>

  <div fxFlex="0 0 225px" class="frame-details-sidebar">
    <mat-card class="frame-thumbnail-card">
      <mat-card-content class="frame-thumbnail-box" (dblclick)="openThumbnail()">
        <img *ngIf="sourceImageUrl" [src]="sourceImageUrl" alt="Uploaded RX">
        <span *ngIf="!sourceImageUrl">UPLOAD RX</span>
        <span class="rx-thumb-hint" *ngIf="sourceImageUrl">DOUBLE-CLICK TO ENLARGE</span>
      </mat-card-content>
    </mat-card>
    <button mat-stroked-button type="button" class="rx-upload-button" [matMenuTriggerFor]="uploadMenu">
      UPLOAD RX
    </button>
    <mat-menu #uploadMenu="matMenu">
      <button mat-menu-item type="button" (click)="photoInput.click()">TAKE PHOTO</button>
      <button mat-menu-item type="button" (click)="fileInput.click()">CHOOSE FILE</button>
    </mat-menu>
    <input #photoInput type="file" accept="image/*" capture="environment" hidden (change)="onUploadSelected($event)">
    <input #fileInput type="file" accept="image/*" hidden (change)="onUploadSelected($event)">

    <div fxLayout="row" fxLayoutAlign="space-around center">
      <button mat-icon-button type="button" (click)="emailRx()" aria-label="Email RX">
        <mat-icon>email</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="printRx()" aria-label="Print RX">
        <mat-icon>print</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="clearUploadedImage()" aria-label="Clear image">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <mat-card style="margin-top:10px;" class="order-commit-card">
      <mat-card-content class="order-commit-card-content">
        <app-last-editor-field [orderForm]="orderForm"></app-last-editor-field>

        <mat-form-field class="order-initials-field" floatLabel="never">
          <input matInput required placeholder="" type="text" [formControl]="orderForm.controls.initials">
          <mat-label><mat-icon>gesture</mat-icon></mat-label>
        </mat-form-field>

        <app-order-save-menu
          [orderForm]="orderForm"
          variant="prescription"
          [canSave]="canSaveRx"
          (saveOrder)="onSave($event.destination)"
        ></app-order-save-menu>
      </mat-card-content>
    </mat-card>
  </div>
</div>
